import { sendToApi } from 'api/client'

export const GithubClient = {
  getResource: (workspaceId: number, resourceName: 'issue' | 'pull', repo: string, number: string) =>
    sendToApi<any>(`/w/${workspaceId}/github/${resourceName}s/${number}?${resourceName}[repo]=${repo}`),
}
